

import Vue from 'vue'
import Component from 'vue-class-component'

@Component
export default class Notification extends Vue {
  public showError (message: string, onCloseHandler: Function = (): any => void 0): any {
    this.$q.notify({
      message,
      color: 'red',
      textColor: 'black',
      position: 'top',
      onDismiss () {
        onCloseHandler()
      }
    })
  }
}
